import React, { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components/native';
import _ from 'lodash';
import { TextInput, View } from 'react-native';
import Icon from './Icon';

const Search = ({rawData, setter = (list)=>console.log(list)}) => {
    const [query, setQuery] = useState(null);
    const [showReset, setShowReset] = useState(false);

    useEffect(()=>{
        if(query != null && query.length > 0){
            setShowReset(true);
        } else {
            if(query != null){
                search();
            }
            setShowReset(false);
        }
    }, [query]);

    const reset = (event) => {
        setQuery("");
    }

    const search = () => {
        const filteredData = _.filter(rawData, (r)=> {
            return JSON.stringify(r).toLowerCase().indexOf( query.toLowerCase() ) >= 0;
        });

        setter(filteredData);
    }

    const keyPress = (event) => {
        if(event.code == "Enter"){
            search();
        }
    }

    const _setQuery = (event) => {
        setQuery(event.currentTarget.value);
    }

    return <View style={{flexDirection: "row", alignItems: "center"}}>
        <View style={{flexDirection: "row", marginRight: 15}}>
            <StyledTextInput value={query} onKeyPress={(e)=>keyPress(e)} onChange={(e)=>_setQuery(e)}/> 
            { showReset ? <ResetIcon icon="times-square" onClick={()=>reset()} size={30}/> : null}	
        </View>
        <Icon icon="search" onClick={()=>search()}/>
    </View>;
}

const StyledTextInput = styled.TextInput`
    height: 40px;
    border-radius: 4px;
    border: 1px solid #c9c9c9;
    padding: 5px;
    color: #4d4d4f;
    font-family: "Red Hat Display";
    font-size: 15px;
    font-weight: 400;
    width: 300px;
    padding-right: 40px;
`;

const ResetIcon = styled(Icon)`
    position: absolute;
    left: -35px;
    top: 5px;
`;

export default Search;